import FILTER_TYPES from '@/components/query/filter-types';
import ConditionOperators from '@/components/query/spec/condition-operators';
import FilterSet from '@/components/query/filter-set';

export const specialFields = [
    {
        category: '/special',
        fields: {
            randomChance: {
                type: FILTER_TYPES.random,
                predicate: ({op}) => op === ConditionOperators.random,
            },
        },
    },
];

/**
 * Special resolve logic to find the field by using a
 * custom predicate.
 * @param op
 * @return {*}
 */
export function getSpecialResourceFieldPath({op}) {
    let path = null;
    specialFields.forEach((level) => {
        Object.keys(level.fields)
            .forEach((fieldName) => {
                if (level.fields[fieldName].predicate
                    && level.fields[fieldName].predicate({op})) {
                    path = `${level.category}${FilterSet.delimiter}${fieldName}`;
                }
            });
    });
    return path;
}
